import { Popover } from '@amzn/awsui-components-react'
import React from 'react'
import { RuleLongLink } from '../../TableItemLink'
import { PropertyList } from '../../PropertyList'

interface RulesTableEntryProps {
    rules: string[]
}

const RulesTableEntry: React.FC<RulesTableEntryProps> = ({rules}) => {
    const buildPopoverContent = () => <PropertyList items={rules.map(rule => <RuleLongLink ruleGroupRuleName={rule} />)} />

    switch (rules.length) {
        case 0:
            return <span>No Rules</span>
        case 1:
            return <RuleLongLink ruleGroupRuleName={rules[0]} />
        default:
            return <Popover size="large" content={buildPopoverContent()}>
                {rules.length} Rules
            </Popover>
    }
}

export default RulesTableEntry

